import { memo } from 'react';
import { Image, StyleProps } from '@chakra-ui/react';

import BloxLogoV1 from 'assets/BloxLogoV1.png';

interface LogoV2Properties {
  onClick?: () => void;
  styles?: StyleProps;
}

const LogoV2 = memo(({ onClick, styles }: LogoV2Properties) => {
  return <Image src={BloxLogoV1} alt='logo' onClick={onClick} {...(styles as any)} />;
});

LogoV2.displayName = 'LogoV2';

export default LogoV2;
